export function tagsToArray(tags?: string): string[] {
  if (!tags?.trim()) return []
  return tags.split(/[,，]/).map((s) => s.trim()).filter(Boolean)
}

export function tagsFromForm(v: string | string[] | undefined): string {
  if (!v) return ''
  if (Array.isArray(v)) return v.map((s) => String(s).trim()).filter(Boolean).join(',')
  return String(v).trim()
}
